import React, { useState } from "react";
import Header from "./Header";
import Footer from "./Footer";
import "../css/returns.scss";
import { Link } from "react-router-dom";

function Returns() {
  const [expandedItems, setExpandedItems] = useState({});

  const toggleItem = (index) => {
    setExpandedItems((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  return (
    <div className="prestige--v4 features--heading-small features--heading-uppercase template-index">
      <div className="PageContainer">
        <Header />
        <main id="main" role="main">
          <div
            id="shopify-section-template--17866867900500__main"
            className="shopify-section"
          >
            <section
              data-section-type="faq"
              data-section-id="template--17866867900500__main"
            >
              <div className="Container">
                <div className="PageContent ">
                  <div className="PageLayout">
                    <div className="PageLayout__Section PageLayout__Section--secondary PageLayout__Section--sticky hidden-phone">
                      <ol className="FaqSummary">
                        <li className="FaqSummary__Item is-active">
                          <Link
                            onClick={toTop}
                            to="#block-23f35d8f-6034-4dc4-a5f5-6bc7b890b904"
                            className="FaqSummary__Link"
                            data-offset={80}
                          >
                            <span className="FaqSummary__LinkLabel">
                              Shipping &amp; Returns
                            </span>
                          </Link>
                        </li>
                      </ol>
                    </div>
                    <div className="PageLayout__Section">
                      <div className="Faq">
                        <h1 className="Faq__Section Heading u-h1">
                          <span
                            className="Anchor"
                            id="block-23f35d8f-6034-4dc4-a5f5-6bc7b890b904"
                          />
                          Shipping &amp; Returns
                        </h1>
                        <div
                          className={`Faq__Item ${
                            expandedItems[0] ? "is-expanded" : ""
                          }`}
                          aria-expanded={expandedItems[0] ? "true" : "false"}
                        >
                          <span className="Faq__Icon">
                            <svg
                              className="Icon Icon--select-arrow-right "
                              role="presentation"
                              viewBox="0 0 11 18"
                            >
                              <path
                                d="M1.5 1.5l8 7.5-8 7.5"
                                strokeWidth={2}
                                stroke="currentColor"
                                fill="none"
                                fillRule="evenodd"
                                strokeLinecap="square"
                              />
                            </svg>
                          </span>
                          <div className="Faq__ItemWrapper">
                            <button
                              className="Faq__Question"
                              onClick={() => toggleItem(0)}
                            >
                              Shipping Options
                            </button>
                            <div
                              className="Faq__AnswerWrapper"
                              aria-hidden={!expandedItems[0]}
                              style={{ height: expandedItems[0] ? "auto" : 0 }}
                            >
                              <div className="Faq__Answer Rte">
                                <p>
                                  We offer free Standard shipping on all US
                                  orders at and above $75. Please note that the
                                  shipping threshold applies to the total paid
                                  after discounts are applied and before taxes.
                                  Orders below $75 will be charged a fee for
                                  shipping and handling.
                                </p>
                                <p>
                                  Please note, orders placed after 1pm EST with
                                  an expedited shipping method will be shipped
                                  the following business day.
                                  <br />
                                  <br />
                                  Orders being shipped to P.O. Boxes will be
                                  delivered via USPS through our Standard
                                  shipping method. Expedited and Rush shipping
                                  options are available for an additional fee.
                                  Selecting expedited shipping at checkout does
                                  not change the production time for custom
                                  items. Once your item has been produced, it
                                  will be sent with the shipping method selected
                                  at checkout. Please refer to the product page
                                  for production timeline.
                                  <br />
                                  <br />
                                  We do not currently ship outside of the United
                                  States, but don't worry - we are working on
                                  adding this option soon!
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className={`Faq__Item ${
                            expandedItems[1] ? "is-expanded" : ""
                          }`}
                          aria-expanded={expandedItems[1] ? "true" : "false"}
                        >
                          <span className="Faq__Icon">
                            <svg
                              className="Icon Icon--select-arrow-right "
                              role="presentation"
                              viewBox="0 0 11 18"
                            >
                              <path
                                d="M1.5 1.5l8 7.5-8 7.5"
                                strokeWidth={2}
                                stroke="currentColor"
                                fill="none"
                                fillRule="evenodd"
                                strokeLinecap="square"
                              />
                            </svg>
                          </span>
                          <div className="Faq__ItemWrapper">
                            <button
                              className="Faq__Question"
                              onClick={() => toggleItem(1)}
                            >
                              Shipping Policy
                            </button>
                            <div
                              className="Faq__AnswerWrapper"
                              aria-hidden={!expandedItems[1]}
                              style={{ height: expandedItems[1] ? "auto" : 0 }}
                            >
                              <div className="Faq__Answer Rte">
                                <p>
                                  We process and ship orders from our New Jersey
                                  warehouse Monday through Friday. When your
                                  order ships, you will receive a shipping
                                  confirmation email containing your tracking
                                  information. Please check your spam folder if
                                  you did not receive this email. Once your
                                  order is placed, we are unable to upgrade your
                                  shipping selection or change your shipping
                                  address.
                                  <br />
                                  <br />
                                  If you have a Bakimball account, you can track
                                  your order by clicking "Account" and then "My
                                  Orders".
                                  <br />
                                  <br />
                                  Custom items will ship after their stated
                                  production timelines, which can be found on
                                  their respective product pages, at checkout,
                                  and in your order confirmation email. <br />
                                  All orders are charged at the time of
                                  purchase, inclusive of pre-sale and custom
                                  items.
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className={`Faq__Item ${
                            expandedItems[2] ? "is-expanded" : ""
                          }`}
                          aria-expanded={expandedItems[2] ? "true" : "false"}
                        >
                          <span className="Faq__Icon">
                            <svg
                              className="Icon Icon--select-arrow-right "
                              role="presentation"
                              viewBox="0 0 11 18"
                            >
                              <path
                                d="M1.5 1.5l8 7.5-8 7.5"
                                strokeWidth={2}
                                stroke="currentColor"
                                fill="none"
                                fillRule="evenodd"
                                strokeLinecap="square"
                              />
                            </svg>
                          </span>
                          <div className="Faq__ItemWrapper">
                            <button
                              className="Faq__Question"
                              onClick={() => toggleItem(2)}
                            >
                              Do you ship to PO Boxes and/or FPO/APO addresses?
                            </button>
                            <div
                              className="Faq__AnswerWrapper"
                              aria-hidden={!expandedItems[2]}
                              style={{ height: expandedItems[2] ? "auto" : 0 }}
                            >
                              <div className="Faq__Answer Rte">
                                <p>
                                  We do ship to PO boxes, but we’re unable to
                                  ship to FPO/APO addresses at this time. If you
                                  select standard shipping at checkout and have
                                  both a street address and a PO Box, please use
                                  your PO Box address to ensure delivery.
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className={`Faq__Item ${
                            expandedItems[3] ? "is-expanded" : ""
                          }`}
                          aria-expanded={expandedItems[3] ? "true" : "false"}
                        >
                          <span className="Faq__Icon">
                            <svg
                              className="Icon Icon--select-arrow-right "
                              role="presentation"
                              viewBox="0 0 11 18"
                            >
                              <path
                                d="M1.5 1.5l8 7.5-8 7.5"
                                strokeWidth={2}
                                stroke="currentColor"
                                fill="none"
                                fillRule="evenodd"
                                strokeLinecap="square"
                              />
                            </svg>
                          </span>
                          <div className="Faq__ItemWrapper">
                            <button
                              className="Faq__Question"
                              onClick={() => toggleItem(3)}
                            >
                              I ordered a custom item and I'm still waiting for
                              it. When will it ship?
                            </button>
                            <div
                              className="Faq__AnswerWrapper"
                              aria-hidden={!expandedItems[3]}
                              style={{ height: expandedItems[3] ? "auto" : 0 }}
                            >
                              <div className="Faq__Answer Rte">
                                <p>
                                  You can view the shipping timeline for custom
                                  items on the product page, in your cart, at
                                  checkout, and in your order confirmation
                                  email. Our custom items are made to order, so
                                  they take a little extra time to create, but
                                  we promise they’re worth the wait!
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className={`Faq__Item ${
                            expandedItems[4] ? "is-expanded" : ""
                          }`}
                          aria-expanded={expandedItems[4] ? "true" : "false"}
                        >
                          <span className="Faq__Icon">
                            <svg
                              className="Icon Icon--select-arrow-right "
                              role="presentation"
                              viewBox="0 0 11 18"
                            >
                              <path
                                d="M1.5 1.5l8 7.5-8 7.5"
                                strokeWidth={2}
                                stroke="currentColor"
                                fill="none"
                                fillRule="evenodd"
                                strokeLinecap="square"
                              />
                            </svg>
                          </span>
                          <div className="Faq__ItemWrapper">
                            <button
                              className="Faq__Question"
                              onClick={() => toggleItem(4)}
                            >
                              Return Policy
                            </button>
                            <div
                              className="Faq__AnswerWrapper"
                              aria-hidden={!expandedItems[4]}
                              style={{ height: expandedItems[4] ? "auto" : 0 }}
                            >
                              <div className="Faq__Answer Rte">
                                <p>
                                  Merchandise, unless marked as final sale or
                                  otherwise noted, can be returned for a full
                                  refund to your original form of payment within
                                  30 days of purchase.
                                  <br />
                                  <br />
                                  Products must be returned unused, with tags,
                                  and in the original packaging. Gift sets must
                                  be returned in their entirety to be eligible
                                  for a refund. Original shipping charges are
                                  not refundable.
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className={`Faq__Item ${
                            expandedItems[5] ? "is-expanded" : ""
                          }`}
                          aria-expanded={expandedItems[5] ? "true" : "false"}
                        >
                          <span className="Faq__Icon">
                            <svg
                              className="Icon Icon--select-arrow-right "
                              role="presentation"
                              viewBox="0 0 11 18"
                            >
                              <path
                                d="M1.5 1.5l8 7.5-8 7.5"
                                strokeWidth={2}
                                stroke="currentColor"
                                fill="none"
                                fillRule="evenodd"
                                strokeLinecap="square"
                              />
                            </svg>
                          </span>
                          <div className="Faq__ItemWrapper">
                            <button
                              className="Faq__Question"
                              onClick={() => toggleItem(5)}
                            >
                              Holiday 2025 Return Policy
                            </button>
                            <div
                              className="Faq__AnswerWrapper"
                              aria-hidden={!expandedItems[5]}
                              style={{ height: expandedItems[5] ? "auto" : 0 }}
                            >
                              <div className="Faq__Answer Rte">
                                <p>
                                  We know holiday shopping can start early, so
                                  we’ve extended our return window to make
                                  things a little easier!
                                </p>
                                <p>
                                  Any&nbsp;<strong>eligible</strong>&nbsp;unused
                                  and unworn merchandise purchased between
                                  November 1, 2025 and December 16, 2025 can be
                                  returned until January 15, 2026 for a full
                                  refund to your original form of payment.
                                  Returned packages must be postmarked by
                                  January 15, 2026 to qualify for a refund.
                                </p>
                                <p>
                                  Orders placed after December 16, 2025 will
                                  follow our standard 30-day return policy.
                                </p>
                                <p>
                                  Please note that custom, made-to-order, and
                                  final sale items aren’t eligible for return.
                                  To confirm if your item qualifies, check the
                                  product page or your order confirmation. All
                                  returns must include unused items with tags
                                  attached and in their original packaging.
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className={`Faq__Item ${
                            expandedItems[6] ? "is-expanded" : ""
                          }`}
                          aria-expanded={expandedItems[6] ? "true" : "false"}
                        >
                          <span className="Faq__Icon">
                            <svg
                              className="Icon Icon--select-arrow-right "
                              role="presentation"
                              viewBox="0 0 11 18"
                            >
                              <path
                                d="M1.5 1.5l8 7.5-8 7.5"
                                strokeWidth={2}
                                stroke="currentColor"
                                fill="none"
                                fillRule="evenodd"
                                strokeLinecap="square"
                              />
                            </svg>
                          </span>
                          <div className="Faq__ItemWrapper">
                            <button
                              className="Faq__Question"
                              onClick={() => toggleItem(6)}
                            >
                              How to Make a Return
                            </button>
                            <div
                              className="Faq__AnswerWrapper"
                              aria-hidden={!expandedItems[6]}
                              style={{ height: expandedItems[6] ? "auto" : 0 }}
                            >
                              <div className="Faq__Answer Rte">
                                <p>
                                  To initiate a return, head over to our{" "}
                                  <Link onClick={toTop} to="/returns">
                                    returns portal
                                  </Link>
                                  . From there, you can choose whether you'd
                                  like an exchange, store credit, or a refund to
                                  the original form of payment. We've also made
                                  it hassle-free by providing a prepaid return
                                  shipping label for your convenience, which you
                                  will be able to access once the return is
                                  submitted. Then just box up the item(s) and
                                  send it back to us! If you need any additional
                                  assistance or questions about returns, please
                                  email us at vert@bakimball.world.
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className={`Faq__Item ${
                            expandedItems[7] ? "is-expanded" : ""
                          }`}
                          aria-expanded={expandedItems[7] ? "true" : "false"}
                        >
                          <span className="Faq__Icon">
                            <svg
                              className="Icon Icon--select-arrow-right "
                              role="presentation"
                              viewBox="0 0 11 18"
                            >
                              <path
                                d="M1.5 1.5l8 7.5-8 7.5"
                                strokeWidth={2}
                                stroke="currentColor"
                                fill="none"
                                fillRule="evenodd"
                                strokeLinecap="square"
                              />
                            </svg>
                          </span>
                          <div className="Faq__ItemWrapper">
                            <button
                              className="Faq__Question"
                              onClick={() => toggleItem(7)}
                            >
                              Gift Returns
                            </button>
                            <div
                              className="Faq__AnswerWrapper"
                              aria-hidden={!expandedItems[7]}
                              style={{ height: expandedItems[7] ? "auto" : 0 }}
                            >
                              <div className="Faq__Answer Rte">
                                <p>
                                  If you received a Bakimball item as a gift and
                                  wish to return it, you'll need the original
                                  order details to start the process. If you
                                  don't have this information, email us at
                                  vert@bakimball.world, and we’ll help locate it
                                  for you!
                                  <br />
                                  <br />
                                  If you do have the original purchaser’s
                                  details, visit our{" "}
                                  <Link onClick={toTop} to="/returns">
                                    returns portal
                                  </Link>{" "}
                                  and select "Start Gift Return Here." After
                                  entering the original order information and
                                  your details, you can choose between an
                                  exchange or store credit. To make things easy,
                                  we provide a prepaid return shipping label,
                                  which will be available once your return is
                                  submitted. Simply package the item(s) and send
                                  them back—rest assured, the original gift
                                  giver won’t be notified!
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className={`Faq__Item ${
                            expandedItems[8] ? "is-expanded" : ""
                          }`}
                          aria-expanded={expandedItems[8] ? "true" : "false"}
                        >
                          <span className="Faq__Icon">
                            <svg
                              className="Icon Icon--select-arrow-right "
                              role="presentation"
                              viewBox="0 0 11 18"
                            >
                              <path
                                d="M1.5 1.5l8 7.5-8 7.5"
                                strokeWidth={2}
                                stroke="currentColor"
                                fill="none"
                                fillRule="evenodd"
                                strokeLinecap="square"
                              />
                            </svg>
                          </span>
                          <div className="Faq__ItemWrapper">
                            <button
                              className="Faq__Question"
                              onClick={() => toggleItem(8)}
                            >
                              Address Changes
                            </button>
                            <div
                              className="Faq__AnswerWrapper"
                              aria-hidden={!expandedItems[8]}
                              style={{ height: expandedItems[8] ? "auto" : 0 }}
                            >
                              <div className="Faq__Answer Rte">
                                <p>
                                  Please verify shipping address before
                                  completing an order. We process orders
                                  quickly, and cannot guarantee that changes can
                                  be made after an order has been placed. Please
                                  email us at vert@bakimball.world if there is
                                  an issue with the address, and we will do our
                                  best to help.
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className={`Faq__Item ${
                            expandedItems[9] ? "is-expanded" : ""
                          }`}
                          aria-expanded={expandedItems[9] ? "true" : "false"}
                        >
                          <span className="Faq__Icon">
                            <svg
                              className="Icon Icon--select-arrow-right "
                              role="presentation"
                              viewBox="0 0 11 18"
                            >
                              <path
                                d="M1.5 1.5l8 7.5-8 7.5"
                                strokeWidth={2}
                                stroke="currentColor"
                                fill="none"
                                fillRule="evenodd"
                                strokeLinecap="square"
                              />
                            </svg>
                          </span>
                          <div className="Faq__ItemWrapper">
                            <button
                              className="Faq__Question"
                              onClick={() => toggleItem(9)}
                            >
                              Items not eligible for returns
                            </button>
                            <div
                              className="Faq__AnswerWrapper"
                              aria-hidden={!expandedItems[9]}
                              style={{ height: expandedItems[9] ? "auto" : 0 }}
                            >
                              <div className="Faq__Answer Rte">
                                <p>
                                  We do not accept returns for any custom-made
                                  products and final sale merchandise. This
                                  information is also outlined on each
                                  respective product page, at checkout, and on
                                  your order confirmation email.
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className={`Faq__Item ${
                            expandedItems[10] ? "is-expanded" : ""
                          }`}
                          aria-expanded={expandedItems[10] ? "true" : "false"}
                        >
                          <span className="Faq__Icon">
                            <svg
                              className="Icon Icon--select-arrow-right "
                              role="presentation"
                              viewBox="0 0 11 18"
                            >
                              <path
                                d="M1.5 1.5l8 7.5-8 7.5"
                                strokeWidth={2}
                                stroke="currentColor"
                                fill="none"
                                fillRule="evenodd"
                                strokeLinecap="square"
                              />
                            </svg>
                          </span>
                          <div className="Faq__ItemWrapper">
                            <button
                              className="Faq__Question"
                              onClick={() => toggleItem(10)}
                            >
                              Price Adjustments
                            </button>
                            <div
                              className="Faq__AnswerWrapper"
                              aria-hidden={!expandedItems[10]}
                              style={{ height: expandedItems[10] ? "auto" : 0 }}
                            >
                              <div className="Faq__Answer Rte">
                                <p>We do not offer price adjustments.</p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className={`Faq__Item ${
                            expandedItems[11] ? "is-expanded" : ""
                          }`}
                          aria-expanded={expandedItems[11] ? "true" : "false"}
                        >
                          <span className="Faq__Icon">
                            <svg
                              className="Icon Icon--select-arrow-right "
                              role="presentation"
                              viewBox="0 0 11 18"
                            >
                              <path
                                d="M1.5 1.5l8 7.5-8 7.5"
                                strokeWidth={2}
                                stroke="currentColor"
                                fill="none"
                                fillRule="evenodd"
                                strokeLinecap="square"
                              />
                            </svg>
                          </span>
                          <div className="Faq__ItemWrapper">
                            <button
                              className="Faq__Question"
                              onClick={() => toggleItem(11)}
                            >
                              Gift Boxes &amp; Pouches
                            </button>
                            <div
                              className="Faq__AnswerWrapper"
                              aria-hidden={!expandedItems[11]}
                              style={{ height: expandedItems[11] ? "auto" : 0 }}
                            >
                              <div className="Faq__Answer Rte">
                                <p>
                                  You can purchase gift boxes separately on our
                                  site, however, we do not offer gift wrapping.
                                  Please note, gift boxes are not intended for
                                  custom blankets and throws.
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className={`Faq__Item Faq__Item--lastOfSection ${
                            expandedItems[12] ? "is-expanded" : ""
                          }`}
                          aria-expanded={expandedItems[12] ? "true" : "false"}
                        >
                          <span className="Faq__Icon">
                            <svg
                              className="Icon Icon--select-arrow-right "
                              role="presentation"
                              viewBox="0 0 11 18"
                            >
                              <path
                                d="M1.5 1.5l8 7.5-8 7.5"
                                strokeWidth={2}
                                stroke="currentColor"
                                fill="none"
                                fillRule="evenodd"
                                strokeLinecap="square"
                              />
                            </svg>
                          </span>
                          <div className="Faq__ItemWrapper">
                            <button
                              className="Faq__Question"
                              onClick={() => toggleItem(12)}
                            >
                              Do you have a customer care phone number?
                            </button>
                            <div
                              className="Faq__AnswerWrapper"
                              aria-hidden={!expandedItems[12]}
                              style={{ height: expandedItems[12] ? "auto" : 0 }}
                            >
                              <div className="Faq__Answer Rte">
                                <p>
                                  We do not have a phone line. Please email our
                                  team at vert@bakimball.world so we can assist
                                  you!
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </main>

        <Footer />
      </div>
    </div>
  );
}

export default Returns;
